/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 9bb85993f0b9a04c8215a689498f8e61 */

import { ConcreteRequest } from "relay-runtime";

export type userTrackingQueryVariables = {
    hasCheckoutUserId: boolean;
    checkoutUserId: string;
    hasUserId: boolean;
    isLoggedIn: boolean;
    userId: string;
};
export type userTrackingQueryResponse = {
    readonly viewer: {
        readonly transactionsCounter?: {
            readonly submittedTransactions?: number | null | undefined;
            readonly confirmedTransactions?: number | null | undefined;
            readonly guestCheckoutTransactions: number | null;
        } | null | undefined;
        readonly user?: {
            readonly isVerifiedTrade: boolean | null;
        } | null | undefined;
    };
};
export type userTrackingQuery = {
    readonly response: userTrackingQueryResponse;
    readonly variables: userTrackingQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "checkoutUserId"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasCheckoutUserId"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasUserId"
    } as any, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLoggedIn"
    } as any, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userId"
    } as any, v5 = {
        "condition": "hasCheckoutUserId",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "buyerId",
                        "variableName": "checkoutUserId"
                    }
                ],
                "concreteType": "TransactionsCounter",
                "kind": "LinkedField",
                "name": "transactionsCounter",
                "plural": false,
                "selections": [
                    {
                        "alias": "guestCheckoutTransactions",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "guest",
                        "storageKey": null
                    },
                    {
                        "condition": "hasUserId",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "alias": "submittedTransactions",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "submitted",
                                "storageKey": null
                            },
                            {
                                "alias": "confirmedTransactions",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "confirmed",
                                "storageKey": null
                            }
                        ]
                    }
                ],
                "storageKey": null
            }
        ]
    } as any, v6 = [
        {
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any
    ], v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isVerifiedTrade",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "userTrackingQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v5 /*: any*/),
                        {
                            "condition": "isLoggedIn",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v6 /*: any*/),
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ]
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/)
            ],
            "kind": "Operation",
            "name": "userTrackingQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v8 /*: any*/),
                        (v5 /*: any*/),
                        {
                            "condition": "isLoggedIn",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v6 /*: any*/),
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/),
                                        (v8 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ]
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/userTrackingQuery",
            "metadata": {},
            "name": "userTrackingQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '2e221747b7b26afdf87834db0b530298';
export default node;
